var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFiltericon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5",
    "data-name": "Group 5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.821,
    height: 14.83,
    viewBox: "0 0 14.821 14.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 14.821,
    height: 14.83,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1.332,11.107c0-.957,0-1.914,0-2.87a.321.321,0,0,0-.2-.333A1.957,1.957,0,0,1,0,6.091,1.947,1.947,0,0,1,1.131,4.254a.336.336,0,0,0,.2-.358c-.005-1.034-.008-2.067,0-3.1A.719.719,0,1,1,2.767.772c.006.615,0,1.23,0,1.845,0,.436.008.871,0,1.307a.3.3,0,0,0,.186.318A1.96,1.96,0,0,1,4.1,6.1,1.953,1.953,0,0,1,2.943,7.92a.3.3,0,0,0-.171.327q0,2.819,0,5.638a2.3,2.3,0,0,1-.018.358.71.71,0,0,1-1.39.04,1.865,1.865,0,0,1-.03-.382q0-1.4,0-2.794Z",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M105.625,11.152c0-.957,0-1.914,0-2.871a.356.356,0,0,0-.22-.375,1.942,1.942,0,0,1-1.115-1.822,1.931,1.931,0,0,1,1.1-1.8.374.374,0,0,0,.234-.393c-.01-1,0-2,0-3a1.17,1.17,0,0,1,.045-.405.709.709,0,0,1,.747-.465.673.673,0,0,1,.626.611c.03.339.021.683.021,1.024,0,.761,0,1.521,0,2.282a.3.3,0,0,0,.183.318A1.947,1.947,0,0,1,108.393,6.1a1.95,1.95,0,0,1-1.157,1.823c-.172.087-.174.2-.174.35q0,2.807,0,5.614a2.062,2.062,0,0,1-.025.382.71.71,0,0,1-1.4-.046,2.313,2.313,0,0,1-.013-.307q0-1.384,0-2.769",
    transform: "translate(-93.572 -0.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M53.466,3.924c0-1.008.018-2.017-.007-3.024-.014-.59.33-.891.731-.889.446,0,.712.332.712.878q0,3.063,0,6.126a.351.351,0,0,0,.212.375,1.956,1.956,0,0,1,1.124,1.818,1.955,1.955,0,0,1-1.117,1.821.354.354,0,0,0-.221.371c.011.905.009,1.811,0,2.717a.7.7,0,0,1-.634.716.705.705,0,0,1-.772-.532,1.226,1.226,0,0,1-.026-.3c0-.88-.005-1.76,0-2.64a.3.3,0,0,0-.189-.311,1.963,1.963,0,0,1-1.148-1.829,1.968,1.968,0,0,1,1.16-1.847.277.277,0,0,0,.175-.294c0-1.051,0-2.1,0-3.153",
    transform: "translate(-46.773 -0.01)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltericon);
export default __webpack_public_path__ + "static/media/filtericon.696beffa8fbc916ab2379772c6ca231b.svg";
export { ForwardRef as ReactComponent };